import { SbBlokData, StoryblokImage } from '@cinch-nx/data-storyblok'
import { StoryblokRenderer } from '@cinch-nx/storyblok-utils'
import { FinanceOfferCard } from '@cinch-nx/ui-finance'
import { ReactNode } from 'react'
import { atomStoryblokComponents } from '../../data-maps/atom-storyblok-components-map'

interface FinanceOfferCardBlockProps {
  image: StoryblokImage
  banner: string
  title: string
  offerDetail1: string
  offerDetail2: string
  offerDetail3: string
  offerDetail4: string
  footerText: string
  cta?: SbBlokData[]
}

export const FinanceOfferCardBlock = ({
  image,
  banner,
  title,
  offerDetail1,
  offerDetail2,
  offerDetail3,
  offerDetail4,
  footerText,
  cta,
}: FinanceOfferCardBlockProps) => {
  const renderedCtaButton: ReactNode | undefined = cta?.length ? (
    <StoryblokRenderer block={cta} components={atomStoryblokComponents} />
  ) : undefined

  return (
    <FinanceOfferCard
      image={{ src: image.filename, alt: image.alt ?? '' }}
      banner={banner}
      title={title}
      offerDetails={[offerDetail1, offerDetail2, offerDetail3, offerDetail4]}
      footerText={footerText}
      ctaButton={renderedCtaButton}
    />
  )
}
